export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.1389c1ac.worker.js");
}
